import React, { FC, useContext, useEffect, useState } from "react";
import { OpenIdProvider, OpenIdSettings } from "../Interfaces/AuthInterfaces";
import AuthContext from "../../contexts/AuthContext";
import { Input, Button, Dimmer, Loader } from "semantic-ui-react";
import { toast } from "react-toastify";
import { config } from "../../contexts/UrlContext";
import axios, { AxiosResponse } from "axios";
import { Dropdown } from "semantic-ui-react";
import { postRequest } from "../../services/axiosService";

const OpenIdTypeOptions = [
    { key: '0', text: 'None', value: 0 },
    { key: '1', text: 'Microsoft', value: 1},
    { key: '2', text: 'Okta', value: 2 }
]

const OpenIdConfig:FC = () => {

    const { auth, openIdSettings } = useContext(AuthContext);

    const [loading, setLoading] = useState<boolean>(false);
    const [settings, setSettings] = useState<OpenIdSettings>({} as OpenIdSettings);
    const [tenantId, setTenantId] = useState<string>("");
    const [selectedType, setSelectedType] = useState<number>(0);

    useEffect(() => {
        setSelectedType(openIdSettings.type);

        if (openIdSettings.type === OpenIdProvider.Okta) {
            //Need to remove the /oauth2/default from the authority url in settings
            let authSettings = openIdSettings;
            authSettings.authority = authSettings.authority.replace("/oauth2/default", "");
            setSettings(authSettings);
        }
        else {
            setSettings(openIdSettings);
        }
    }, [openIdSettings]);

    const saveSettings = async () => { 
        setLoading(true);
        try {
            settings.type = selectedType;
            let response: AxiosResponse = await postRequest(auth, `/Auth/SaveAuthConfig`, settings);
            
            toast.success("Settings saved");
            toast.warning("Please restart the application pool in IIS for changes to take effect");
        } catch (error) {
            toast.error("Error saving settings");
        }
        setLoading(false);
    }

    if (loading) {
        return (
            <Dimmer inverted active={true}>
                <Loader inverted>Loading...</Loader>
            </Dimmer>
        );
    }

    return (
        <div className="ui admin-container" id="appearance-settings">
            <div className="header blue headerStyleBlue">Open ID Connect Settings</div>

            <div style={{ marginTop: 10 }} className="header gray headerStyleGray">TYPE</div>   
            <Dropdown
                style={{ marginLeft: 10, backgroundColor: "#e5e5e5" }}
                placeholder='Select Type'
                fluid
                selection
                options={OpenIdTypeOptions}
                value={selectedType}
                onChange={(e, data: any) => { setSelectedType(data.value); setSettings({...settings, type: data.value})}} 
            />

            {selectedType !== OpenIdProvider.None &&
            <>
                <div style={{ marginTop: 10 }} className="header gray headerStyleGray">CLIENT ID</div>
                <div className="ui input fluid" style={{ marginLeft: '10px', width: '100%' }} >
                    <input style={{ backgroundColor: "#e5e5e5" }} value={settings.clientId} onChange={(e) => { setSettings({ ...settings, clientId: e.target.value }) }} />
                </div>

                <div className="header gray headerStyleGray">AUTHORITY</div>
                <div className="ui input fluid" style={{ marginLeft: '10px', width: '100%' }} >
                    <input style={{ backgroundColor: "#e5e5e5" }} value={settings.authority} onChange={(e) => { setSettings({ ...settings, authority: e.target.value }) }} />
                </div>

                <div className="header gray headerStyleGray">REDIRECT URI</div>
                <div className="ui input fluid" style={{ marginLeft: '10px', width: '100%' }} >
                    <input style={{ backgroundColor: "#e5e5e5" }} value={settings.redirectUri} onChange={(e) => { setSettings({ ...settings, redirectUri: e.target.value }) }} />
                </div>
            </>
            }

            <div style={{ display: "flex", alignItems: "flex-end", justifyContent: "left", alignContent: "stretch", margin: 10 }}>
                <Button id="appearance-save" style={{ marginTop: 20 }} onClick={saveSettings}>Save</Button>
                <Button id="appearance-cancel" style={{ marginTop: 20, marginLeft: 5 }} onClick={() => { setSettings(openIdSettings) }}>Cancel</Button>
            </div>
        </div>
    );
}

export default OpenIdConfig;